import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { processesRepo } from '@/constants/providers';
import { Process } from '@/modules/Processes/domain';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { ProcessKey } from './keys';

export const useGetProcessesByBusinessArea = (
  businessAreaId: number,
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<DataWithPagination<Process[]>>,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<DataWithPagination<Process[]>>(
    [
      ...ProcessKey.BY_BUSINESS_AREA_PAGED(businessAreaId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      processesRepo.getProcessesByBusinessArea(
        businessAreaId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    options,
  );
};

export const useGetAllProcessesByBusinessArea = (businessAreaId?: number) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery(
    [...ProcessKey.BY_BUSINESS_AREA(businessAreaId), currentSelectedTenant?.id],
    () => {
      if (!businessAreaId) return [];
      return processesRepo.getProcessesBaseInfoByBusinessArea(businessAreaId);
    },
    {
      enabled: !!businessAreaId,
    },
  );
};
